import { IMediaFile } from '../../media-library';

export enum PromotionSpecialTag {
  ONLY_TODAY = 'ONLY_TODAY',
  WEEK_PROMOTION = 'WEEK_PROMOTION',
  MONTH_PROMOTION = 'MONTH_PROMOTION',
  POPULAR = 'POPULAR',
  NEW = 'NEW',
  BEST_CHOICE = 'BEST_CHOICE',
  RECOMMENDED = 'RECOMMENDED',
  DONT_MISS = 'DONT_MISS',
}

/** Single promotion displayed in the promotions widget. */
export interface IPromotionsObject {
  active?: boolean | Record<string, boolean>;
  id?: string;
  position?: number;
  cover?: IMediaFile[];
  title: Record<string, string>;
  specialTag?: PromotionSpecialTag | null;
  description?: Record<string, string>;
}

/** Collection of promotions offered to guests. */
export interface IPromotionsWidget {
  description?: Record<string, string>;
  title?: Record<string, string>;
  objects?: IPromotionsObject[];
}

